import React from 'react';

const Brochure27 = () => {
  return (
    <div>
      <h1>Brochure</h1>
    </div>
  );
};

export default Brochure27;